var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30.005,
    viewBox: "0 0 30 30.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatboxes",
    "data-name": "Icon ionic-ios-chatboxes",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M30.419,11.981H14.434a2.752,2.752,0,0,0-2.748,2.748V25.86A2.746,2.746,0,0,0,14.434,28.6h9.146a.788.788,0,0,1,.548.231l4.544,4.191c.252.245.671.144.671-.209v-3.65c0-.433.274-.57.707-.57h.072a3,3,0,0,0,3.037-2.741V14.73A2.737,2.737,0,0,0,30.419,11.981Z",
    transform: "translate(0.215 0.223)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M12.493,10.437h12.8V5.727a2.352,2.352,0,0,0-2.352-2.352H5.727A2.352,2.352,0,0,0,3.375,5.727V17.643a2.352,2.352,0,0,0,2.352,2.352h4.407V12.788A2.363,2.363,0,0,1,12.493,10.437Z",
    transform: "translate(0 0)",
    fill: "#111"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messages-icon.02178031e322ffa5b316c88f1efdfae2.svg";
export { ForwardRef as ReactComponent };